// Bwek 크로스프로모 — 설정창 하단 배너의 링크 디스패처 + 노출 게이트.
// ★OS별 분기 필수: iOS 빌드→App Store / Android 빌드→Play / 웹→Bwek 웹.
// ★Bwek이 없는 스토어(OS)에선 배너를 숨긴다 — 깨진 링크 = 리뷰 리젝 사유.
import { Capacitor } from "@capacitor/core";
import { track } from "./analytics";

const BWEK = {
  web: "https://bwek.app",
  android: "https://play.google.com/store/apps/details?id=web.bwek.app",
  // Bwek iOS는 App Store 승인 후 켠다 — 그 전엔 iOS Hyuh 빌드에서 배너 숨김(깨진 링크 방지).
  // 승인 후: enabled:true + 실제 App Store URL(apps.apple.com/app/idXXXX)로 교체.
  ios: { url: "https://apps.apple.com/app/id0000000000", enabled: false },
};

function isNative(): boolean {
  return Capacitor.isNativePlatform();
}
function isIOS(): boolean {
  return Capacitor.getPlatform() === "ios"; // iPad(iPadOS)도 'ios'
}

/** 배너 노출 여부. Bwek이 없는 스토어에선 숨김(현재 iOS 네이티브). 웹·Android는 노출. */
export function bwekPromoVisible(): boolean {
  if (isNative() && isIOS() && !BWEK.ios.enabled) return false;
  return true;
}

/** 이동 URL: iOS 네이티브→App Store / Android 네이티브→Play / 웹(브라우저)→Bwek 웹. */
export function bwekUrl(): string {
  if (!isNative()) return BWEK.web;
  if (isIOS()) return BWEK.ios.enabled ? BWEK.ios.url : BWEK.web; // (iOS는 숨김이라 보통 도달 안 함)
  return BWEK.android;
}

/** 클릭: 전환 출처 태깅 + 외부로 열기. */
export function openBwek(): void {
  try {
    track("crosspromo_click", { source: "hyuh_settings", target: "bwek" });
  } catch {
    /* 분석 실패 무시 */
  }
  window.open(bwekUrl(), "_blank", "noopener");
}
